module.exports = __webpack_public_path__ + "static/media/remove-icon.af5301a8.svg";